import { Product } from 'shared/types/product/Product';
import { ExtendedVariant } from 'shared/types/product/Variant';

/**
 * Backend product descriptions sometimes carry internal merchandising notes
 * ("... on the parent product", "... for the e-commerce website") that must never
 * reach a meta description or JSON-LD payload.
 */
const JUNK_DESCRIPTION_PATTERN = /parent product|e-commerce website/i;

export const BRAND_NAME = 'Viewrail';

/**
 * Customer-facing name for a product. The first variant's name is the merchandised
 * one; the parent product name is often an internal identifier.
 */
export const getProductDisplayName = (product?: Pick<Product, 'name'> & { variants?: ExtendedVariant[] }) =>
  product?.variants?.[0]?.name ?? product?.name ?? '';

export const isJunkProductDescription = (description?: string) =>
  !!description && JUNK_DESCRIPTION_PATTERN.test(description);

export const getGeneratedProductDescription = (displayName: string) =>
  `${displayName} — quality stair parts, railing, and hardware from ${BRAND_NAME}.`;

/**
 * Returns the description if it is usable, otherwise a generated blurb built from
 * the display name. Returns an empty string when there is no display name to build on.
 */
export const getProductDescription = (description: string | undefined, displayName: string) => {
  const trimmedDescription = description?.trim();

  if (trimmedDescription && !isJunkProductDescription(trimmedDescription)) {
    return trimmedDescription;
  }

  return displayName ? getGeneratedProductDescription(displayName) : '';
};
